import { defaultPOICalloutBoxConfig as e } from "./index.es74.js";
const t = {
  date_preset: "last-12-months",
  limit: 10,
  sort_by: "foot_traffic",
  sub_category: [],
  chain_ids: [],
  within: {
    spatialType: "NO_FILTER",
    spatialDistance: 0
  }
}, a = {
  withinPolygon: {
    visible: !1,
    fitBound: !1
  },
  isGrouped: !0,
  showHeaderForGrouped: !0,
  showHeaderForUngrouped: !1,
  poiCalloutBoxConfig: {
    ...e,
    headerContainerColor: "#979797"
  },
  offsetMap: {},
  hiddenPOIs: []
};
export {
  t as NearbyDefaultFetchFilter,
  a as NearbyDefaultVisualFilter
};
//# sourceMappingURL=index.es72.js.map
